import { LeadService } from "../../libs/ui/src/abstractServices/apiServices/leadService";
import { mlClient } from "../apiService";

const leadService = new LeadService({ client: mlClient });

export { leadService as LeadService };
